export default class MenuItem {
    ID: number | undefined;
    guid: string | undefined;
    title: string | undefined;

    constructor(item: any) {
        Object.assign(this, item);
    }
}
